import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders, HttpBackend } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { BehaviorSubject } from 'rxjs';

export interface CountryData {
  ip: string;
  country: string;
}

export const SPECIAL_COUNTRY_CODE : string = 'CN';
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private login = new BehaviorSubject(true);
  login$ = this.login.asObservable();
  public countryEvent: Subject<boolean> = new Subject();

  private changeCard = new BehaviorSubject(true);
  changeCard$ = this.changeCard.asObservable();

  private changeLanguage = new BehaviorSubject(null);
  public changeLanguage$ = this.changeLanguage.asObservable();

  public changeLanguageEmit(selectedLanguage: any): void {
    sessionStorage.setItem("userLanguage", JSON.stringify(selectedLanguage));
    this.changeLanguage.next(selectedLanguage);
  };

  apiUrlBsV1 = environment.apiUrlBsV1;

  constructor(
    private http: HttpClient
  ) { }



  emitLogin(data: any) {
    this.login.next(data)
  }

  changeCardEmit(data: any) {
    this.changeCard.next(data)
  }

processCountries(res){
  if(res && res.data && res.data.length > 0){
    const originalCountries = res.data;
    let toIgnore = ['bra', 'gbr', 'syr', 'irn', 'rus'];
    res.data.forEach((obj, key) => {
      if(toIgnore.includes(obj.attributes.iso_code.toLowerCase())){
        originalCountries.splice(key,1);
      }
    })
    originalCountries.forEach(obj => {
      obj.attributes.name = this.transformCountryName(obj.attributes.name);
      obj.attributes.flag_url = this.getFlagUrl(obj.attributes.iso_code);
    });


    localStorage.setItem("allCountries", JSON.stringify(originalCountries));
    let allCountries = originalCountries;
    // allCountries.sort(function (a, b) {
    //   var textA = a.attributes.name.toUpperCase();
    //   var textB = b.attributes.name.toUpperCase();
    //   return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    // });

    allCountries.forEach(obj => {
      let mobile_length = obj.attributes.mobile_length.split('...');
      obj.attributes.min_mobile_digit = parseInt(mobile_length[0]);
      obj.attributes.max_mobile_digit = parseInt(mobile_length[1]);
      // if (this.featuredCountryCodes.includes(obj.attributes.iso_code)) {
      //   this.popularCountries.push(obj);
      // } else {
        this.otherCountries.push(obj);
      // }
    })

    // sort popular countries array w.r.t featured array
    // this.popularCountries.sort( (a, b) => {
    //   return this.featuredCountryCodes.indexOf(a.attributes.iso_code) - this.featuredCountryCodes.indexOf(b.attributes.iso_code);
    // });

    // alphabetically sort other countries
    this.otherCountries.sort(function (a, b) {
      var textA = a.attributes.name.toUpperCase();
      var textB = b.attributes.name.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
    // allCountries = this.popularCountries.concat(this.otherCountries);
    allCountries = this.otherCountries;
    return {
      data: allCountries,
      ip_country: res.ip_country ? res.ip_country : null
    };
  }
  else{
    return [];
  }

}
  getAllCountries(countryCode?) {
    if(!countryCode){
      var countryCode;
    }
    let allCountries;
    return allCountries = this.http.get(environment.apiUrlCsV1 + "/countries").pipe(
      map(res => {
        this.otherCountries = [];
        return this.processCountries(res);
      }),
      catchError(error => throwError(error))
    );

  }
  featuredCountryCodes = ['IND', 'SGP', 'ARE', 'AUS', 'USA', 'GBR', 'CAN', 'SAU', 'KWT', 'QAT', 'BHR', 'OMN', 'HKG', 'NZL', 'BGD'];
  popularCountries = [];
  otherCountries = [];
  allCountries: any = [];

  filteredCountries = [];
  countrySearchTerm = '';
  filterItem(searchTerm){
   if(searchTerm && searchTerm.length > 0){
      this.filteredCountries = Object.assign([], this.allCountries).filter(
        item => item.attributes.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
     )
   }
   else{
     this.filteredCountries = this.allCountries;
   }
  }

  public getLanguages() {
    return this.http.get(environment.apiUrlCsV1 + "languages").pipe(
      map(res => res),
      catchError(error => throwError(error))
    );
  }

  public sendAnalyticsData(type: string, payloadType:string , payloadValue: any) {
    window['adobeDataLayer'] = window['adobeDataLayer'] || [];
    const adobeData = { 'event': type};
    adobeData[payloadType] = payloadValue; 
    window['adobeDataLayer'].push(adobeData);
  }

  public isDeviceMobile(): boolean {
    return window.innerWidth <= 768;
  }

  public getCountryCode(): string {
    return localStorage.getItem('countryCode') ?? "";
  }

  public isChinaIpLocation(): boolean {
    return this.getCountryCode() === SPECIAL_COUNTRY_CODE;
  }

  public transformCountryName(countryName:string): string {
    const  COUNTRY_NAME_MAP: Record<string, string> = {
      'china': 'Chinese Mainland, China',
      'hong kong': 'Hong Kong SAR, China',
    };
    const COUNTRY_NAME_MAP_FOR_CHINA: Record<string, string>= {
      ...COUNTRY_NAME_MAP,
      'taiwan': 'Taiwan, China',
      'macao': 'Macau SAR, China',
    }
      if (this.isChinaIpLocation()) {
        const transformedName = COUNTRY_NAME_MAP_FOR_CHINA[countryName.toLowerCase()];
        return transformedName || countryName;
      }
    const transformedName = COUNTRY_NAME_MAP[countryName.toLowerCase()];
    return transformedName || countryName;
  }

  public getFlagUrl(isoCode:string): string | null {
    if (this.isChinaIpLocation()) {
        return null;
      }
    return `https://images.poshvine.com/flags/${isoCode.toLowerCase()}.jpg`;
  }

  private getCountryData(): Observable<CountryData | any[]> {
    return this.http.get<CountryData>('https://api.country.is/').pipe(
      map((res: CountryData) => res || []),
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }

  public setCountryData(): Promise<void> {
    return new Promise((resolve) => {
      if (localStorage.getItem('countryCode')) {
        resolve();
        return;
      }
      this.getCountryData().subscribe({
        next: (res: CountryData) => {
          localStorage.setItem('countryCode',res.country);
          resolve();
        }
      });
    });
  }
}
